import {
  Users,
  Settings,
  HelpCircle,
  UserIcon,
  Database,
  FileText,
} from 'lucide-react';
import type { SidebarData } from './appSidebar.models';

export const sidebarData: SidebarData = {
  user: {
    name: 'John Doe',
    email: 'john@example.com',
    avatar: '/avatars/user.jpg',
  },
  navGroups: [
    {
      title: 'General',
      items: [
        {
          title: 'Datasets',
          url: '/datasets',
          icon: Database,
        },
        {
          title: 'Documents',
          url: '/documents',
          icon: FileText,
        },
        {
          title: 'Users',
          url: '/users',
          icon: Users,
        },
      ],
    },
    {
      title: 'Settings',
      items: [
        {
          title: 'Settings',
          icon: Settings,
          items: [
            {
              title: 'Profile',
              url: '/settings/profile',
              icon: UserIcon,
            },
          ],
        },
        {
          title: 'Help & Support',
          icon: HelpCircle,
          items: [
            {
              title: 'Documentation',
              url: '/help/docs',
            },
            {
              title: 'FAQ',
              url: '/help/faq',
            },
          ],
        },
      ],
    },
  ],
};
